import cx from 'classnames'

type Props = {
  name: string | undefined
  hasError: boolean
  isReplacer: boolean
}

const TopicCardName = ({ name, hasError, isReplacer }: Props) => {
  return name ? (
    <div
      className={cx(
        'text-base font-medium overflow-ellipsis overflow-hidden whitespace-nowrap w-44',
        {
          'text-red-600': hasError,
          'text-coolGray-800': !hasError,
        }
      )}
    >
      {isReplacer ? name.replace(';', ', ') : name}
    </div>
  ) : null
}

export default TopicCardName
